import { Composition as CompositionComponent } from './Composition.component';
import { connector } from './Composition.connector';

export const Composition = connector(CompositionComponent);
